import { useMemo } from 'react';
import { useAtom } from 'jotai';
import { atomWithQuery } from 'jotai-tanstack-query';
import { ticketService } from '@/services/ticket.service';

export const ticketThreadQueryAtom = (externalTicketId: string | null) =>
  atomWithQuery(() => ({
    queryKey: ['tickets', externalTicketId, 'thread'],
    queryFn: () => ticketService.getThread(externalTicketId as string),
    enabled: Boolean(externalTicketId),
    retry: 1,
    staleTime: 5 * 60 * 1000
  }));

export function useTicketThread(externalTicketId: string | null) {
  const atom = useMemo(() => ticketThreadQueryAtom(externalTicketId), [externalTicketId]);
  const [query] = useAtom(atom);
  return query;
}
